import * as LucideIcons from 'lucide-react';

/**
 * Converts kebab-case icon names to PascalCase for Lucide React
 */
export function convertIconName(iconName: string): string {
  return iconName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
}

/**
 * Gets a Lucide icon component by name, with fallback to Info icon
 */
export function getLucideIcon(iconName: string): React.ComponentType<any> {
  const convertedName = convertIconName(iconName);
  const IconComponent = (LucideIcons as any)[convertedName];
  
  if (IconComponent) {
    return IconComponent;
  }
  
  // Fallback to Info icon if the specified icon doesn't exist
  return LucideIcons.Info;
}